import { useAlert } from '@orientaction/hooks';
import { getFromLS, getUserLanguageById, isAdmin } from '@orientaction/utils';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import { deleteMyAccount } from '../../../../../services/user.service';

type UseProfileEditFormParams = {
  user: Record<string, any>;
  updateUser: (data: Record<string, any>) => Promise<any>;
};

export const useProfileEditForm = ({ user, updateUser }: UseProfileEditFormParams) => {
  const [selectedLanguage, setSelectedLanguage] = useState('FR');
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  const { setOpenAlert } = useAlert();
  const userInfos = JSON.parse(getFromLS('userInfos') || '{}');
  const mainLink = userInfos.username === 'Admin' ? '/results' : '/main';
  const history = useHistory();

  const {
    control,
    formState: { errors },
    handleSubmit,
  } = useForm<any>({
    mode: 'onChange',
  });

  const onSelectLanguage = (code: string): void => {
    setSelectedLanguage(code);
  };

  const goBack = () => {
    history.push(mainLink);
  };

  const onSubmitHandler = async (data: Record<string, any>) => {
    try {
      await updateUser({ ...data, language: selectedLanguage === 'GB' ? 2 : 1 });
    } catch {
      // Alert handled in useUser.updateUserById
    }
  };

  const deleteAccount = async () => {
    setOpenDeleteModal(false);
    try {
      const token = getFromLS('userToken') || '';
      await deleteMyAccount(token);
      setOpenAlert(true, "Votre compte vient d'être supprimé avec succès", 'success');
      localStorage.clear();
      history.push('/');
    } catch (e) {
      console.error(e);
      setOpenAlert(true, 'Un erreur est survenue', 'error');
    }
  };

  useEffect(() => {
    if (user?.id) {
      setSelectedLanguage(getUserLanguageById(user?.language?.id));
    }
  }, [user?.id, user?.language?.id]);

  return {
    control,
    errors,
    handleSubmit,
    selectedLanguage,
    onSelectLanguage,
    goBack,
    onSubmitHandler,
    deleteAccount,
    openDeleteModal,
    setOpenDeleteModal,
    isAdminUser: isAdmin(userInfos),
  };
};
